import { cn } from "@/lib/utils";
import React from "react";

type Props = {
  message?: string | boolean;
  label?: string | boolean;
  error?: string;
  className?: string;
};

const FormLabel: React.FC<Props> = ({ label = "-", error, className = "" }) => {
  return (
    <label
      className={cn(
        "text-[14px] font-semibold  my-2 block text-nowrap",
        error ? "!text-red-400" : "",
        className
      )}
    >
      {label} {error && "*"}
    </label>
  );
};

const ErrorLabel: React.FC<Props> = ({ message = "", ...props }) => {
  return (
    <div
      className={cn([
        "text-[12px] mt-1 capitalize text-red-600",
        props.className,
      ])}
    >
      {message}
    </div>
  );
};

export { FormLabel, ErrorLabel };
